import { createStore, applyMiddleware } from 'redux';
import reducers from 'src/store/reducers';

const store = createStore(reducers, {}, applyMiddleware());

export default store;
